const MaybeSmall = ({ text, max }: { text: string; max: number }) => {
  if (text.length > max) return <span className="font-small-md">{text}</span>
  return <>{text}</>
}

export default MaybeSmall
